<template>

   <div class="content-wrapper">
      <div id="overlay" v-if="processingAPI">
         <div class="spinner"></div>
         <span class="text-center badge bg-green fs-14" style="margin-top:110px;">Processing...</span>
      </div>
      <div class="content-header">
         <div class="container-fluid">

            <div class="row" v-if="isHiddenMain">
               <div class="col-10">
                  <span class="m-0 text-dark h-title">Loan Releasing</span>
               </div>
            </div>

            <div class="row" v-if="isHiddenPDF">
               <div class="col-8">
                  <span class="m-0 text-dark h-title">{{label_LRA}}</span>
               </div>
               <div class="col-4">
                  <button class="btn btn-outline-primary float-right" @click.prevent="routeBack"><i class="mr-1 fas fa-arrow-left"></i>Back</button>
               </div>
            </div>
         </div>
      </div>

      <div class="content" v-if="initLoad">
         <div class="container-fluid">
            <div class="row">
               <div class="col-md-2"></div>
               <div class="col-md-8">
                  <div class="card">
                     <div class="card-body">

                        <div class="row">
                           <div class="col-12">
                              <h4 class="text-center">NOTICE OF APPROVAL</h4>
                           </div>
                        </div>
                        <hr>

                        <div class="row">
                           <div class="col-12">
                              <p class="card-text text-justify">Dear {{formNotice.fmls}},</p>

                              <p class="card-text text-justify">This is to inform you that your loan application with ID number <u class="bold">{{formNotice.application_id}}</u>
                                 in the amount of <u class="bold">{{formNotice.approved_loan_amt | decimal}}</u>
                                 under the <u class="bold">{{formNotice.program_name}}</u>
                                 <!-- of the Small Business Corporation (SB Corporation) has been approved subject to the following conditions: -->
                                 of the Small Business Corporation (SB Corporation) has been approved, subject to the following:
                              </p>
                           </div>

                        </div>

                        <div class="row mt-2">
                           <div class="col-12 table-responsive">
                              <table class="table table-bordered table-sm">
                                 <thead>
                                    <tr>
                                       <th>Particulars </th>
                                       <th>Loan Terms</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr>
                                       <td>Approved Loan Amount </td>
                                       <td><u class="bold">{{formNotice.approved_loan_amt | decimal}}</u></td>

                                    </tr>
                                    <tr>
                                       <td>Repayment Term/Grace Period </td>
                                       <td><u class="bold">{{formNotice.app_repayment_period}}</u> months inclusive of <u class="bold">{{formNotice.approved_gp}}</u> months grace period</td>

                                    </tr>
                                    <tr>
                                       <td>Interest Rate </td>
                                       <td><u class="bold">{{formNotice.interest_rate}}%</u></td>

                                    </tr>
                                    <tr>
                                       <td>Service Fee (one-time) </td>
                                       <td><u class="bold">{{formNotice.service_charge}}%</u> (upfront service fee to be deducted from loan proceeds) </td>

                                    </tr>
                                    <tr>
                                       <td>Penalty Charges </td>
                                       <td><u class="bold">{{formNotice.penalty_rate}}%</u> per month based on unpaid installment due</td>

                                    </tr>
                                    <tr>
                                       <td>Mode of Loan Release</td>
                                       <td><u class="bold">{{formNotice.manner_rel_desc}}</u></td>

                                    </tr>
                                    <tr>
                                       <td>Special Terms and Conditions (if any)</td>
                                       <td>{{formNotice.special_conditions}}</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>

                        </div>


                        <div class="row">
                           <div class="col-12">
                              <p class="card-text text-justify">Please go through the attached Promissory Note, Disclosure Statement/Amortization Schedule, and Loan Agreement (if applicable) to fully understand the terms and conditions of your loan obligation with the SB Corporation.</p>
                              <p class="card-text text-justify">Kindly also acknowledge that the loan proceeds will be released to the bank account/electronic money account that you have indicated on your loan application form, as follows: </p>
                           </div>
                        </div>


                        <div class="row my-3">
                           <div class="col-12 table-responsive">
                              <table class="table table-bordered table-sm">
                                 <tbody>
                                    <tr>
                                       <td>Bank / Electronic Money Account:</td>
                                       <td>{{formNotice.bankname}}</td>

                                    </tr>
                                    <tr>
                                       <td>Account Name:</td>
                                       <td>{{formNotice.acctname}}</td>

                                    </tr>
                                    <tr>
                                       <td>Account Number:</td>
                                       <td>{{formNotice.acctno}}</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>

                        </div>

                        <div class="row">
                           <div class="col-12">
                              <p class="card-text text-justify">Please note that this notice of approval does not in any way preclude SBCorp from exercising its right to discontinue or suspend the disbursement of the
                                 loan proceeds upon discovery of any acts of misrepresentation or involvement in any fraudulent activity by the applicant in relation to his/her loan application with SBCorp.</p>
                              <p class="card-text text-justify">Choose “I Agree” below to signify your consent on the foregoing information in this notice. Otherwise, choose “I do not agree”.</p>
                              <div class="text-center mb-3 fs-20">
                                 <div class="mt-2">
                                    <div class="icheck-primary d-inline mr-3">
                                       <input type="radio" id="radioAgree" name="decide" value='agree' v-model="iAgreeChecked" :class="{'errorRadio ': generating && $v.iAgreeChecked.$error}">
                                       <label for="radioAgree"> I Agree</label>

                                    </div>
                                    <div class="icheck-primary d-inline">
                                       <input type="radio" id="radioDisAgree" name="decide" value='disagree' v-model="iAgreeChecked" :class="{'errorRadio': generating && $v.iAgreeChecked.$error}">
                                       <label for="radioDisAgree">I do not agree</label>

                                    </div>
                                 </div>
                                 <div v-show="generating && $v.iAgreeChecked.$error" class="danger fs-13">Required</div>
                              </div>



                              <div v-show="iAgreeChecked == 'agree'">
                                 <p class="card-text text-justify">Please affix your e-signature on below signature pad to confirm your consent:</p>
                                 <center>
                                    <div class="col-md-6" style="min-width: 200px; max-width:500px;">
                                       <VueSignaturePad id="signature" width="100%" height="200px" ref="signaturePad" :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}" />
                                       <div class="row text-center">
                                          <div class="text-center col-12 mt-2">
                                             <span v-if="formLR.bt_code == 'BT2020001'">Borrower's Signature</span>
                                             <span v-else>Authorized Representative Signature</span><br><br>
                                             <button v-if="wacom" class="btn btn-outline-primary mr-2" @click="openWacom('signaturePad')">Open Signature Tablet</button>
                                             <button class="btn btn-outline-primary mr-2" @click="clearSign">Clear</button>
                                             <button class="btn btn-outline-primary" @click="undo">Undo</button>
                                          </div>
                                       </div>


                                    </div> <br>

                                    <div v-show="formLR.coborrower_id || formLRA_stat.co_signatory" class="col-md-6" style="min-width: 200px; max-width:500px;">
                                       <VueSignaturePad id="cosignature" width="100%" height="200px" ref="cosignaturePad" :options="{onBegin: () => {$refs.cosignaturePad.resizeCanvas()}}" />
                                       <div class="row text-center">
                                          <div class="text-center col-12 mt-2">
                                             <span>Co-Signatory Signature</span> <br><br>
                                             <button v-if="wacom" class="btn btn-outline-primary mr-2" @click="openWacom('cosignaturePad')">Open Signature Tablet</button>
                                             <button class="btn btn-outline-primary mr-2" @click="clearSignCo">Clear</button>
                                             <button class="btn btn-outline-primary" @click="undoCo">Undo</button>
                                          </div>
                                       </div>
                                    </div>
                                 </center>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="card-footer">
                        <button v-if="iAgreeChecked == 'agree'" class="btn btn-primary float-right" @click.prevent="generateOTP">Submit</button>
                        <button v-else class="btn btn-primary float-right" @click.prevent="showLoanCancel">Submit</button>
                        <!-- <span> <button class="btn btn-primary float-right" @click.prevent="generatePDFNotice">generate</button></span> -->

                     </div>
                  </div>
               </div>
               <div class="col-md-2"></div>
            </div>
         </div>
      </div>


      <div class="modal fade" id="generateOTP" tabindex="-1" role="dialog" aria-labelledby="generateOTP" aria-hidden="true" data-backdrop="static" data-keyboard="false">
         <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="generateOTP">One-Time-Pin Verification</h5>
               </div>
               <div class="modal-body">

                  <!-- <div class="alert alert-danger alert-dismissible mb-2" v-if="msg">
                     <button type="button" class="close mt-n1" data-dismiss="alert" aria-hidden="true" @click="msg=null">&times;</button>
                     <span>{{msg}}</span>
                  </div> -->

                  <div class="alert alert-danger alert-dismissible mb-1" v-if="formOTP.invalid">
                     <button type="button" class="close mt-n1" data-dismiss="alert" aria-hidden="true" @click="formOTP.invalid=false">&times;</button>
                     <span>Invalid verification code entered!</span>
                  </div>



                  <p class="card-text" v-if="formLR.otp_type=='sms'">Kindly enter below the OTP we have sent to your registered mobile number <b>{{formLR.mobile_no_hash}}</b> to verify your identity.</b></p>
                  <p class="card-text" v-if="formLR.otp_type=='email'">Kindly enter below the OTP we have sent to your registered email <b>{{formLR.email_hash}}</b> to verify your identity.</b></p>
                  <p class="card-text">It will expire in the next <strong>5 minutes. </strong></p>

                  <center>
                     <input inputmode="numeric" type="text" class="text-center form-control form-control-lg otp" maxlength="6" placeholder="Enter code" v-model="formOTP.code" :class="{ 'is-invalid': generatingOTP && $v.formOTP.code.$error }" />
                     <p class="fs-13 danger m-0 p-0" v-if="generatingOTP && $v.formOTP.code.$error">Verification code must have 6 digit</p>
                     <p class="card-text mt-2 mb-1">Did not received OTP?</p>

                     <div class="mb-1">
                        <button type="button" class="btn btn-link" :disabled="counting" @click="resendOTP('sms')">
                           <countdown v-if="counting" :time="300000" @end="counting=false">
                              <template slot-scope="props">Resend again via SMS {{ props.minutes }} minutes, {{ props.seconds }} seconds later</template>
                           </countdown>
                           <span v-else>Resend OTP code via SMS</span>
                        </button>
                     </div>
                     <div>
                        <button type="button" class="btn btn-link" :disabled="counting2" @click="resendOTP('email')">
                           <countdown v-if="counting2" :time="300000" @end="counting2=false">
                              <template slot-scope="props">Resend again via Email {{ props.minutes }} minutes, {{ props.seconds }} seconds later</template>
                           </countdown>
                           <span v-else>Resend OTP code via Registered Email</span>
                        </button>
                     </div>
                  </center>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-outline-primary mr-auto" @click="cancelOTP">Cancel</button>

                  <button type="button" class="btn btn-primary" ref="otpSubmit" @click='postAcceptance'>Verify</button>
               </div>
            </div>
         </div>
      </div>
      <!-- MODAL OTP -->



      <div class="content" v-if="loadDocument">
         <div class="content-fluid" v-if="isHiddenMain">
            <div class="row">
               <div class="col-md-12">
                  <div class="card">
                     <div class="card-header">
                        <h3 class="card-title fw-600"><strong>Documents requiring signature</strong></h3>
                     </div>
                     <div class="card-body table-responsive">
                        <table class="table table-bordered">
                           <thead>
                              <th>Documents</th>
                              <th>Status</th>
                              <th>Action</th>

                           </thead>
                           <tbody>
                              <tr>
                                 <td>
                                    {{formLabel.LRA00}}
                                 </td>
                                 <td>
                                    <span class="badge fs-13" :class="formLRA_stat.LRA00">{{desc_LRA00}}</span>
                                 </td>
                                 <td>
                                    <button class="btn btn-sm btn-success" @click="loadAttachment(0, formLRA_stat.LRA00)">View</button>
                                 </td>
                              </tr>

                              <tr>
                                 <td>
                                    {{formLabel.LRA01}}
                                 </td>
                                 <td>
                                    <span class="badge fs-13" :class="formLRA_stat.LRA01">{{desc_LRA01}}</span>
                                 </td>
                                 <td>
                                    <button class="btn btn-sm btn-success" @click="loadAttachment(1, formLRA_stat.LRA01)">View</button>
                                 </td>

                              </tr>
                              <tr>
                                 <td>
                                    {{formLabel.LRA07}}
                                 </td>
                                 <td>
                                    <span class="badge fs-13" :class="formLRA_stat.LRA07">{{desc_LRA07}}</span>
                                 </td>
                                 <td>
                                    <button class="btn btn-sm btn-success" @click="loadAttachment(11, formLRA_stat.LRA07)">View</button>
                                 </td>

                              </tr>
                              <tr>
                                 <td>
                                    {{formLabel.LRA02}}
                                 </td>
                                 <td>
                                    <span class="badge fs-13" :class="formLRA_stat.LRA02"> {{desc_LRA02}}</span>
                                 </td>
                                 <td>
                                    <button class="btn btn-sm btn-success" @click="loadAttachment(2, formLRA_stat.LRA02)">View</button>
                                 </td>

                              </tr>
                              <tr>
                                 <td>
                                    {{formLabel.LRA03}}
                                 </td>
                                 <td>
                                    <span class="badge fs-13" :class="formLRA_stat.LRA03">{{desc_LRA03}}</span>
                                 </td>
                                 <td>
                                    <button class="btn btn-sm btn-success" @click="loadAttachment(3, formLRA_stat.LRA03)">View</button>
                                 </td>
                              </tr>
                              <!-- <tr v-if="(formNotice.approved_loan_amt > 300000 && formLR.bt_code == 'BT2020001') || formLR.bt_code != 'BT2020001' || formLR.loan_bus_code == 'FIB10'"> -->
                              <tr v-if="requiredLA">
                                 <td>
                                    {{formLabel.LRA04}}
                                 </td>
                                 <td>
                                    <span class="badge fs-13" :class="formLRA_stat.LRA04">{{desc_LRA04}}</span>
                                 </td>
                                 <td>
                                    <button class="btn btn-sm btn-success" @click="loadAttachment(4, formLRA_stat.LRA04)">View</button>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>

            <div class="row">
               <div class="col-md-12">
                  <div class="card">
                     <div class="card-header">
                        <h3 class="card-title fw-600"><strong>Document/s for uploading</strong></h3>
                     </div>
                     <div class="card-body">

                        <div class="alert alert-success2" role="alert">
                           <p class="fs-15 p-0 m-0 bold">Supported File Format for the following:</p>
                           <div class="row mb-2">
                              <div class="col-xs-12 col-sm-7">
                                 <p class="p-0 m-0">
                                    <span class="badge badge-pill badge-primary">IMG</span> - images [.jpeg, .jpg, .png] [max-size: <b>10MB</b>]
                                 </p>
                              </div>
                              <div class="col-xs-12 col-sm-5">
                                 <p class="p-0 m-0">
                                    <span class="badge badge-pill badge-danger">PDF</span> - [.pdf] [max-size: <b>10MB</b>]
                                 </p>
                              </div>

                           </div>
                        </div>


                        <div class="table-responsive">
                           <table class="table table-bordered">
                              <thead>
                                 <th>Documents</th>
                                 <th>Status</th>
                                 <th>View Sample</th>
                                 <th>Attach</th>
                                 <th>Action</th>

                              </thead>
                              <tbody>
                                 <tr>
                                    <td>
                                       Borrower's Picture holding his/her government-issued IDs <span class="badge badge-pill badge-primary">IMG</span>&nbsp;<span class="badge badge-pill badge-danger">PDF</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="progress" v-if="api.LRA05">
                                          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress.LRA05+';'">
                                             {{progress.LRA05}}
                                          </div>
                                       </div>
                                       <span v-else class="badge fs-13" :class="formLRA_stat.LRA05">{{desc_LRA05}}</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <button class="btn btn-sm btn-outline-primary" @click="viewFileLRA('images/bor-hold-2-id.jpg')">View</button>
                                    </td>
                                    <td class="text-center align-middle">
                                       <label class="btn btn-sm btn-primary nowrap pointer mb0" :class="{ 'file-disabled' : formLRA_stat.LRA05 === 'CL04'}">Select
                                          <span v-show="formLRA.LRA05" class="badge badge-light">1</span>
                                          <input type="file" hidden @change="uploadLRA($event, 'LRA05')" id="LRA05" accept=".png, .jpg, .jpeg, .pdf">
                                       </label>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="btn-group">
                                          <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                             Action
                                          </button>
                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-if="fetchLRA_signed.LRA05">
                                             <a class="dropdown-item pointer" @click="viewFileLRA(fetchLRA_signed.filepath + fetchLRA_signed.LRA05)">View</a>
                                          </div>

                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-else>
                                             <a class="dropdown-item" @click="viewLRA05">View</a>
                                             <a class="dropdown-item pointer" @click="removeLRA05">Remove</a>
                                          </div>

                                       </div>
                                    </td>

                                 </tr>

                                 <tr>
                                    <td>
                                       Picture of Signing of Release Documents by Applicant <span class="badge badge-pill badge-primary">IMG</span>&nbsp;<span class="badge badge-pill badge-danger">PDF</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="progress" v-if="api.LRA08">
                                          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress.LRA08+';'">
                                             {{progress.LRA08}}
                                          </div>
                                       </div>
                                       <span v-else class="badge fs-13" :class="formLRA_stat.LRA08">{{desc_LRA08}}</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <button class="btn btn-sm btn-outline-primary" @click="viewFileLRA('images/bor-signing.jpg')">View</button>
                                    </td>
                                    <td class="text-center align-middle">
                                       <label class="btn btn-sm btn-primary nowrap pointer mb0" :class="{ 'file-disabled' : formLRA_stat.LRA08 === 'CL04'}">Select
                                          <span v-show="formLRA.LRA08" class="badge badge-light">1</span>
                                          <input type="file" hidden @change="uploadLRA($event, 'LRA08')" id="LRA08">
                                       </label>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="btn-group">
                                          <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                             Action
                                          </button>
                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-if="fetchLRA_signed.LRA08">
                                             <a class="dropdown-item pointer" @click="viewFileLRA(fetchLRA_signed.filepath + fetchLRA_signed.LRA08)">View</a>
                                          </div>

                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-else>
                                             <a class="dropdown-item" @click="viewLRA08">View</a>
                                             <a class="dropdown-item pointer" @click="removeLRA08">Remove</a>
                                          </div>

                                       </div>
                                    </td>

                                 </tr>


                                 <tr v-if="formLR.bt_code != 'BT2020001'">
                                    <td>
                                       Notarized Secretary's Certificate and Board Resolution <span class="badge badge-pill badge-primary">IMG</span>&nbsp;<span class="badge badge-pill badge-danger">PDF</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="progress" v-if="api.LRA06">
                                          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress.LRA06+';'">
                                             {{progress.LRA06}}
                                          </div>
                                       </div>
                                       <span v-else class="badge fs-13" :class="formLRA_stat.LRA06">{{desc_LRA06}}</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <button class="btn btn-sm btn-outline-primary" @click="viewFileLRA('templatedPDF/Sample-Notarized.pdf')">View</button>
                                    </td>
                                    <td class="text-center align-middle">
                                       <label class="btn btn-sm btn-primary nowrap pointer mb0" :class="{ 'file-disabled' : formLRA_stat.LRA06 === 'CL04'}">Select
                                          <span v-show="formLRA.LRA06" class="badge badge-light">1</span>
                                          <input type="file" hidden @change="uploadLRA($event, 'LRA06')" id="LRA06">
                                       </label>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="btn-group">
                                          <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                             Action
                                          </button>
                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-if="fetchLRA_signed.LRA06">
                                             <a class="dropdown-item pointer" @click="viewFileLRA(fetchLRA_signed.filepath + fetchLRA.LRA06)">View</a>
                                          </div>

                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-else>
                                             <a class="dropdown-item" @click="viewLRA06">View</a>
                                             <a class="dropdown-item pointer" @click="removeLRA06">Remove</a>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>

                                 <!-- <tr v-if="formNotice.approved_loan_amt >= 150000"> -->
                                 <tr v-if="isPDC">
                                    <td>
                                       Post-Dated Check <span class="badge badge-pill badge-primary">IMG</span>&nbsp;<span class="badge badge-pill badge-danger">PDF</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="progress" v-if="api.LRA09">
                                          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress.LRA09+';'">
                                             {{progress.LRA09}}
                                          </div>
                                       </div>
                                       <span v-else class="badge fs-13" :class="formLRA_stat.LRA09">{{desc_LRA09}}</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <button class="btn btn-sm btn-outline-primary" @click="viewFileLRA('images/sample-pdc.png')">View</button>
                                    </td>
                                    <td class="text-center align-middle">
                                       <label class="btn btn-sm btn-primary nowrap pointer mb0" :class="{ 'file-disabled' : formLRA_stat.LRA09 === 'CL04'}">Select
                                          <span v-show="formLRA.LRA09" class="badge badge-light">1</span>
                                          <input type="file" hidden @change="uploadLRA($event, 'LRA09')" id="LRA09">
                                       </label>
                                    </td>
                                    <td class="text-center align-middle">
                                       <div class="btn-group">
                                          <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                             Action
                                          </button>
                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-if="fetchLRA_signed.LRA09">
                                             <a class="dropdown-item pointer" @click="viewFileLRA(fetchLRA_signed.filepath + fetchLRA.LRA09)">View</a>
                                          </div>

                                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-else>
                                             <a class="dropdown-item" @click="viewLRA09">View</a>
                                             <a class="dropdown-item pointer" @click="removeLRA09">Remove</a>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>


                              </tbody>

                           </table>
                        </div>

                     </div>
                     <div class="card-footer" v-if="formLR.lr_status=='LR09' || formLR.lr_status=='LR10'">
                        <button class="btn btn-success float-right" @click="postLR">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                        <!-- <button class="btn btn-primary float-right mr-2" @click.prevent="startUpload"><i class="fas fa-upload mr-1"></i>Start Upload</button> -->
                     </div>
                  </div>
               </div>

            </div>
         </div>

         <div class="container-fluid" v-if="isHiddenPDF">
            <div class="content">
               <div class="row mt-2">
                  <div class="col-12">
                     <div class="card card-body">
                        <div class="row">
                           <div v-if="routeStat=='CL03' || routeStat=='CL09'" class='col-md-9'>
                              <!-- <div class="embed-responsive embed-responsive-16by9"> class="embed-responsive-item" -->
                              <object :data="fetchLRA.filepath + routeFile + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="" width="100%" height="100%">
                                 <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                                 <center><a :href="fetchLRA.filepath + routeFile" :download="label_LRA" class="btn btn-sm btn-primary"><i class="fas fa-download mr-1"></i>Download File</a></center>
                                 <br>
                              </object>
                              <!-- </div> -->
                           </div>


                           <div v-if="routeStat!='CL03' && routeStat!='CL09'" class='col-md-12'>
                              <!-- <div class="embed-responsive embed-responsive-16by9"> class="embed-responsive-item" -->
                              <object :data="fetchLRA_signed.filepath + routeFile + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="" width="100%" height="100%">
                                 <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                                 <center><a :href="fetchLRA_signed.filepath + routeFile" :download="label_LRA" class="btn btn-sm btn-primary"><i class="fas fa-download mr-1"></i>Download File</a></center>
                                 <br>
                              </object>
                              <!-- </div> -->
                           </div>

                           <div class="col-md-3" v-if="routeStat=='CL03'|| routeStat=='CL09'">
                              <div class="card">
                                 <div class="card-body">
                                    <div v-if="routeKey == 'LRA01'">
                                       <div class="">
                                          <div class="mb-2">
                                             <span>Page 2 for signature (Name and Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig01}">
                                                <img v-if="sigLRA01.sig01" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA01 && !sigLRA01.sig01" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig01=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                          <div class="mb-2">
                                             <span>Page 3 for signature (Specimen Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig02}">
                                                <img v-if="sigLRA01.sig02" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">

                                             </div>
                                             <div v-show="signingLRA01 && !sigLRA01.sig02" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig02=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                          <div class="mb-2">
                                             <span>Page 3 for signature (Specimen Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig03}">
                                                <img v-if="sigLRA01.sig03" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">

                                             </div>

                                             <div v-show="signingLRA01 && !sigLRA01.sig03" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig03=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                          <div class="mb-2">
                                             <span>Page 3 for signature (Specimen Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig04}">
                                                <img v-if="sigLRA01.sig04" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">

                                             </div>
                                             <div v-show="signingLRA01 && !sigLRA01.sig04" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig04=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                       </div>
                                       <div v-show="formLR.coborrower_id || formLRA_stat.co_signatory">
                                          <div class="mb-2">
                                             <span>Page 2 for signature (Coborrower's Name/Co-Signatory and Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig05}">
                                                <img v-if="sigLRA01.sig05" class="img-fluid" :src="formLR.filepath + formLR.SIG02" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA01 && !sigLRA01.sig05" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig05=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                          <div class="mb-2">
                                             <span>Page 3 for signature (Specimen Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig06}">
                                                <img v-if="sigLRA01.sig06" class="img-fluid" :src="formLR.filepath + formLR.SIG02" style="max-height: 100px;">

                                             </div>
                                             <div v-show="signingLRA01 && !sigLRA01.sig06" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig06=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                          <div class="mb-2">
                                             <span>Page 3 for signature (Specimen Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig07}">
                                                <img v-if="sigLRA01.sig07" class="img-fluid" :src="formLR.filepath + formLR.SIG02" style="max-height: 100px;">

                                             </div>

                                             <div v-show="signingLRA01 && !sigLRA01.sig07" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig07=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                          <div class="mb-2">
                                             <span>Page 3 for signature (Specimen Signature)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA01 && !sigLRA01.sig08}">
                                                <img v-if="sigLRA01.sig08" class="img-fluid" :src="formLR.filepath + formLR.SIG02" style="max-height: 100px;">

                                             </div>
                                             <div v-show="signingLRA01 && !sigLRA01.sig08" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA01.sig08=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                       </div>
                                    </div>

                                    <div v-if="routeKey == 'LRA02'">
                                       <div class="">
                                          <div class="mb-2">
                                             <span>Page 1 for signature (Borrower)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA02 && !sigLRA02.sig01}">
                                                <img v-if="sigLRA02.sig01" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA02 && !sigLRA02.sig01" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA02.sig01=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>
                                          <div v-show="formLR.coborrower_id || formLRA_stat.co_signatory" class="mb-2">
                                             <span>Page 1 for signature (Co-Borrower/Co-Signatory)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA02 && !sigLRA02.sig02}">
                                                <img v-if="sigLRA02.sig02" class="img-fluid" :src="formLR.filepath + formLR.SIG02" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA02 && !sigLRA02.sig02" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA02.sig02=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>
                                       </div>
                                    </div>

                                    <!-- <div v-if="routeKey == 'LRA03'">
                                       <div class="">
                                          <div class="mb-2">
                                             <span>Page 1 for signature (Borrower)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA03 && !sigLRA03.sig01}">
                                                <img v-if="sigLRA03.sig01" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA03 && !sigLRA03.sig01" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA03.sig01=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>
                                       </div>
                                    </div> -->

                                    <div v-if="routeKey == 'LRA03'">
                                       <div class="">
                                          <div class="mb-2">
                                             <span>Page 2 for signature (Signature of Borrower Over Printed Name)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA04 && !sigLRA04.sig01}">
                                                <img v-if="sigLRA04.sig01" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA04 && !sigLRA04.sig01" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA04.sig01=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>
                                          <div v-show="formLR.coborrower_id || formLRA_stat.co_signatory" class="mb-2">
                                             <span>Page 2 for signature (Signature of Co-Borrower/Co-Signatory Over Printed Name)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA04 && !sigLRA04.sig02}">
                                                <img v-if="sigLRA04.sig02" class="img-fluid" :src="formLR.filepath + formLR.SIG02" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA04 && !sigLRA04.sig02" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA04.sig02=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>
                                       </div>
                                    </div>

                                    <div v-if="routeKey == 'LRA04'">
                                       <div class="">
                                          <div class="mb-2">
                                             <span>Page 2 for signature (Signature of Borrower Over Printed Name)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA07 && !sigLRA07.sig01}">
                                                <img v-if="sigLRA07.sig01" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA07 && !sigLRA07.sig01" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA07.sig01=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>

                                          <div v-show="formLR.coborrower_id || formLRA_stat.co_signatory" class="mb-2">
                                             <span>Page 2 for signature (Signature of Co-Signatory Over Printed Name)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA07 && !sigLRA07.sig02}">
                                                <img v-if="sigLRA07.sig02" class="img-fluid" :src="formLR.filepath + formLR.SIG02" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA07 && !sigLRA07.sig02" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA07.sig02=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>
                                       </div>
                                    </div>



                                    <div v-if="routeKey == 'LRA07'">
                                       <div class="">
                                          <div class="mb-2">
                                             <span>Page 1 for signature (Borrower)</span>
                                             <div class="attachment-block clearfix" style="height: 100px;" :class="{'reqSig': signingLRA11 && !sigLRA11.sig01}">
                                                <img v-if="sigLRA11.sig01" class="img-fluid" :src="formLR.filepath + formLR.SIG01" style="max-height: 100px;">
                                             </div>
                                             <div v-show="signingLRA11 && !sigLRA11.sig01" class="danger fs-13 mt-n2">Required</div>
                                             <center><button class="btn btn-primary btn-sm" type="button" @click="sigLRA11.sig01=true"><i class="fas fa-signature mr-1"></i> Add Signature</button></center>
                                          </div>
                                       </div>
                                    </div>

                                 </div>

                                 <div class="card-footer">
                                    <button v-if="routeKey == 'LRA01'" class="btn btn-success float-right" type="button" @click="generatePDFLRA01">Proceed<i class="ml-1 fas fa-arrow-right"></i></button>
                                    <button v-if="routeKey == 'LRA02'" class="btn btn-success float-right" type="button" @click="generatePDFLRA02">Proceed<i class="ml-1 fas fa-arrow-right"></i></button>
                                    <!-- <button v-if="routeKey == 'LRA03'" class="btn btn-success float-right" type="button" @click="generatePDFLRA03">Proceed<i class="ml-1 fas fa-arrow-right"></i></button> -->
                                    <button v-if="routeKey == 'LRA03'" class="btn btn-success float-right" type="button" @click="generatePDFLRA04">Proceed<i class="ml-1 fas fa-arrow-right"></i></button>
                                    <button v-if="routeKey == 'LRA04'" class="btn btn-success float-right" type="button" @click="generatePDFLRA07">Proceed<i class="ml-1 fas fa-arrow-right"></i></button>
                                    <button v-if="routeKey == 'LRA07'" class="btn btn-success float-right" type="button" @click="generatePDFLRA11">Proceed<i class="ml-1 fas fa-arrow-right"></i></button>
                                 </div>
                              </div>
                           </div>

                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="modal fade" id="loanCancelModal" tabindex="-1" role="dialog">
         <div class="modal-dialog modal-dialog-centered" role="document">
            <form @submit.prevent="loanCancel">
               <div class="modal-content">
                  <div class="modal-header">
                     <h5 class="modal-title bold">Loan Cancel</h5>
                     <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div class="modal-body">
                     <p>Are you sure?</p>
                     <p>You won't be able to revert this.</p>
                     <div class="form-group">
                        <label>Reason of Loan Cancelled</label>
                        <select class="custom-select form-control" required v-model="reason_cancel">
                           <option value="" disabled selected>Please Select</option>
                           <option value="RC01">Approved loan amount is too small</option>
                           <option value="RC02">Loan processing too long</option>
                           <option value="RC03">Do not want the loan anymore</option>
                        </select>
                     </div>
                  </div>
                  <div class="modal-footer">
                     <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
                     <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
               </div>
            </form>
         </div>
      </div>

      <SigCaptX @init="initWacom" @switch="switchWacom" @submit="submitWacom" :header="wacomHeader" />
   </div>
</template>

<script>
   import moment from 'moment';
   import SigCaptX from '@js/wacom-sdk/SigCaptX.vue';
   import vSelect from 'vue-select'
   Vue.component('v-select', vSelect)

   import {
      required,
      requiredIf,
      minLength,
      email
   } from "vuelidate/lib/validators";
   import {
      Form
   } from 'vform';


   export default {
      components: {
         SigCaptX
      },
      data() {
         return {
            wacomHeader: "Borrower's Signature",
            capture: '',
            wacom: '',
            otpBy: 'email',
            res_arr: [],
            max_size_doc: 1024 * 1024 * 10,
            pdc: false,
            reason_cancel: '',

            sigLRA01: new Form({
               sig01: false,
               sig02: false,
               sig03: false,
               sig04: false,
               sig05: false,
               sig06: false,
               sig07: false,
               sig08: false,
            }),


            sigLRA02: new Form({
               sig01: false,
               sig02: false,
            }),

            sigLRA03: new Form({
               sig01: false,
            }),

            sigLRA04: new Form({
               sig01: false,
               sig02: false
            }),
            sigLRA07: new Form({
               sig01: false,
               sig02: false
            }),

            sigLRA11: new Form({
               sig01: false,
            }),

            counting: false,
            counting2: false,
            downloadLRA01: '',

            downloadLRA02: '',

            downloadLRA03: '',

            downloadLRA04: '',
            downloadLRA07: '',

            routeFile: this.$route.query.f,
            routeStat: this.$route.query.s,
            routeKey: '',
            routeApp: this.$route.query.app,
            arr_label: [{
                  code: 'LRA00',
                  label: 'Notice of Approval (Agree/Disagree) and OTP'
               },
               {
                  code: 'LRA01',
                  label: 'Loan Application and Signature Card'
               },
               {
                  code: 'LRA02',
                  label: 'Promissory Note'
               },
               {
                  // code: 'LRA03',
                  // label: 'Promissory Note'
               },
               {
                  code: 'LRA03',
                  label: 'Disclosure Statement and Amortization Schedule'
               },
               {
                  code: 'LRA04',
                  label: 'Loan Agreement'
               },
               {
                  code: 'LRA07',
                  label: 'Payment Instruction Slip'
               },
            ],

            formLabel: new Form({
               LRA00: 'Notice of Approval (Agree/Disagree) and OTP',
               LRA01: 'Loan Application and Signature Card',
               LRA02: 'Promissory Note',
               // LRA03: 'Promissory Note (Corporation)',
               LRA03: 'Disclosure Statement and Amortization Schedule',
               LRA04: 'Loan Agreement',
               LRA07: 'Payment Instruction Slip'
            }),

            formPDF: new Form({
               account_code: null,
               application_id: '',
               borrower_id: '',
               coborrower_id: '',
               otp: '',
               pathSIG: '',
               pathAttach: '',
               fileSIG01: '',
               fileSIG02: '',
               fileAttach: '',
               bt_code: '',
            }),


            formOTP: new Form({
               // otp1: null,
               // otp2: null,
               // otp3: null,
               // otp4: null,
               // otp5: null,
               // otp6: null,
               // otp: null,
               otp_id: null,

               code: null,
               invalid: false,
               sent: false,
            }),

            formLR: new Form({
               account_code: null,
               application_id: '',
               borrower_id: '',
               otp: '',
               filepath: '',
               SIG01: '',
               SIG02: '',
               lr_status: '',
               mobile_number: '',
               mobile_no: '',
               signature1: '',
               signature2: '',
               isEmpty: '',
               isEmptyCo: '',
               verification_code: null,
               bt_code: '',
               mobile_no_hash: '',
               coborrower_id: null,
               cp_lname: '',
               business_name: '',
               req_loan_amt: '',
               co_signatory: '',
               program: '',
               loan_bus_code: '',
               session_id: null,
               email: '',
               email_hash: '',
               otp_type: 'sms',
            }),

            fetchLRA: new Form({
               application_id: '',
               release_date: '',
               application_date: '',
               filepath: '',
               LRA00: null,
               LRA01: null,
               LRA02: null,
               LRA03: null,
               LRA04: null,
               LRA05: null,
               LRA06: null,
               LRA07: null,
               LRA: null,

               LRA08: null,
               LRA09: null,

            }),

            fetchLRA_signed: new Form({
               application_id: '',
               filepath: '',
               LRA00: null,
               LRA01: null,
               LRA02: null,
               LRA03: null,
               LRA04: null,
               LRA05: null,
               LRA06: null,
               LRA07: null,
               LRA: null,
               LRA08: null,
               LRA09: null,
            }),

            isHiddenPDF: false,
            isHiddenMain: true,



            formLRA: new Form({
               application_id: '',
               LRA05: '',
               LRA06: '',
               LRA08: '',
               LRA09: ''
            }),

            formNotice: new Form({
               account_code: '',
               acctname: '',
               acctno: '',
               app_repayment_period: '',
               application_id: '',
               approved_gp: '',
               approved_loan_amt: '',
               bankname: '',
               borrower_id: '',
               bt_code: '',
               business_name: '',
               first_due_amt: '',
               first_due_date: '',
               fmls: '',
               interest_rate: '',
               manner_rel: '',
               manner_rel_desc: '',
               maturity: '',
               penalty_rate: '',
               program_name: '',
               // recom_loan_term: '',
               service_charge: '',
               special_conditions: ''
            }),

            formLRA_stat: new Form({
               borrower_id: '',
               account_code: '',
               application_id: '',
               LRA00: null,
               LRA01: null,
               LRA02: null,
               LRA03: null,
               LRA04: null,
               LRA05: null,
               LRA06: null,
               LRA07: null,
               LRA08: null,
               LRA09: null,
               remarks: null,
               resubmit: null,
               lr_status: null,
               co_signatory: null,
               created_at: null,
            }),


            isSigned: true,
            iAgreeChecked: '',


            api: {
               loan_release: false,
               generate_otp: false,
               post_acceptance: false,
               attachment: false,
               bor_stat: false,
               post_lr: false,
               complete_lra01: false,
               complete_lra02: false,
               complete_lra03: false,
               complete_lra04: false,
               complete_lra07: false,
               signingLRA01: false,
               signingLRA02: false,
               signingLRA03: false,
               signingLRA04: false,
               signingLRA07: false,
               loan_release00: false,
               loan_release000: false,

               LRA05: false,
               LRA06: false,
               LRA08: false,
               LRA09: false,

            },
            filePDF: ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'],

            progress: {
               LRA05: null,
               LRA06: null,
               LRA08: null,
               LRA09: null,
            },

            generating: false,
            generatingOTP: false,
            signingLRA01: false,
            signingLRA02: false,
            signingLRA03: false,
            signingLRA04: false,
            signingLRA07: false,

            signingLRA11: false,

            arr_lrv: [{
                  code: 'CL02',
                  description: 'For Uploading'
               }, // primary
               {
                  code: 'CL03',
                  description: 'For Signature'
               }, //info (#563d7c)
               {
                  code: 'CL07',
                  description: 'Signed'
               }, // success
               {
                  code: 'CL01',
                  description: 'For Verification'
               }, //orange
               {
                  code: 'CL04',
                  description: 'Verified'
               }, //orange
               {
                  code: 'CL08',
                  description: 'Uploaded'
               }, //danger
               {
                  code: 'CL06',
                  description: 'Failed to upload'
               }, //danger
               {
                  code: 'CL09',
                  description: 'Resignature/Reupload'
               }, //danger
            ],


         }
      },
      validations: {
         iAgreeChecked: {
            required
         },

         formOTP: {
            // otp1: {
            //    required
            // },
            // otp2: {
            //    required
            // },
            // otp3: {
            //    required
            // },
            // otp4: {
            //    required
            // },
            // otp5: {
            //    required
            // },
            // otp6: {
            //    required
            // },
            code: {
               required
            },


         },

         sigLRA01: {
            sig01: {
               required
            },
            sig02: {
               required
            },
            sig03: {
               required
            },
            sig04: {
               required
            },
         }

      },

      methods: {
         submitWacom(data) {
            $('#modalWacom').modal('hide');
            const image = new Image();
            image.onload = () => {
               const canvas = this.$refs[this.capture].$el.querySelector("canvas");
               const ctx = canvas.getContext("2d");
               canvas.width = image.width;
               canvas.height = image.height;
               ctx.drawImage(image, 0, 0);
            };
            image.src = data;
            this.$refs[this.capture].fromDataURL(data);
         },
         switchWacom() {
            $('#modalPad').modal('show');
         },
         initWacom(val) {
            this.wacom = val;
         },
         openWacom(val) {
            this.capture = val;
            this.wacomHeader = val == 'signaturePad' ? "Borrower's Signature" : "Co-Signatory Signature";
            $('#modalWacom').modal('show');
         },

         amountWords(s) {
            // System for American Numbering 
            var th_val = ['', 'thousand', 'million', 'billion', 'trillion'];
            var dg_val = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
            var tn_val = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
            var tw_val = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

            s = s.toString();
            s = s.replace(/[\, ]/g, '');
            if (s != parseFloat(s))
               return 'not a number ';
            var x_val = s.indexOf('.');
            if (x_val == -1)
               x_val = s.length;
            if (x_val > 15)
               return 'too big';
            var n_val = s.split('');
            var str_val = '';
            var sk_val = 0;
            for (var i = 0; i < x_val; i++) {
               if ((x_val - i) % 3 == 2) {
                  if (n_val[i] == '1') {
                     str_val += tn_val[Number(n_val[i + 1])] + ' ';
                     i++;
                     sk_val = 1;
                  } else if (n_val[i] != 0) {
                     str_val += tw_val[n_val[i] - 2] + ' ';
                     sk_val = 1;
                  }
               } else if (n_val[i] != 0) {
                  str_val += dg_val[n_val[i]] + ' ';
                  if ((x_val - i) % 3 == 0)
                     str_val += 'hundred ';
                  sk_val = 1;
               }
               if ((x_val - i) % 3 == 1) {
                  if (sk_val)
                     str_val += th_val[(x_val - i - 1) / 3] + ' ';
                  sk_val = 0;
               }
            }
            if (x_val != s.length) {
               var y_val = s.length;
               /*         str_val += 'point ';
                       for (var i = x_val + 1; i < y_val; i++)
                           str_val += dg_val[n_val[i]] + ' '; */
               var x = s.split('.').pop();
               if (x > 0) {
                  str_val += 'and ' + x + '/100'
               }
            }
            return str_val.replace(/\s+/g, ' ').toUpperCase();

         },

         handler($event) {
            $event.preventDefault();
            // event.stopPropagation();
         },

         say(msg) {
            alert(msg);
         },
         tickPDC() {
            this.pdc = !this.pdc;

            if (this.pdc) {
               this.formLRA_stat.LRA09 = 'CL04';
            } else {
               this.formLRA_stat.LRA09 = '';
            }
         },
         resendOTP: _.debounce(function(otp_type) {
            this.formOTP.code = null;
            this.api.generate_otp = true;
            this.formLR.otp_type = otp_type
            this.formLR.post('api/lr-generate-otp')
               .then(response => {
                  this.api.generate_otp = false;
                  let data = response.data;
                  if (otp_type == 'sms') {
                     this.counting = true;
                  }
                  if (otp_type == 'email') {
                     this.counting2 = true;
                  }
                  this.formLR.session_id = data.session_id;
               }).catch(error => {
                  this.api.generate_otp = false;
                  console.log(error);
               });
         }, 500),

         handleCountdownEnd: function() {
            this.counting = false;
         },

         showLoanCancel() {
            this.generating = true;
            this.$v.iAgreeChecked.$touch();
            if (this.$v.iAgreeChecked.$invalid) {
               Swal.fire({
                  html: `<span class="fs-22 bold">Please fill-out all required fields</span>`,
                  icon: 'info',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  confirmButtonText: 'Ok',
               })
            } else {
               $('#loanCancelModal').modal('show');
            }

         },

         loanCancel: _.debounce(function() {
            $('#loanCancelModal').modal('hide');
            this.api.post_lr = true;

            axios.post('/api/lr-loan-cancel', {
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  borrower_id: this.formLR.borrower_id,
                  reason_cancel: this.reason_cancel
               })
               .then(response => {
                  this.api.post_lr = false;

                  Swal.fire({
                     icon: 'success',
                     title: 'Loan Cancelled Successfully!',
                     allowEscapeKey: false,
                     allowOutsideClick: false,
                     allowEnterKey: false,
                     confirmButtonText: 'Ok',
                  }).then((result) => {
                     if (result) {
                        axios.post('/logout').then(response => {
                           window.location.href = "/login";
                        }).catch(error => {

                        });
                     }
                  })

               }).catch(error => {
                  this.api.post_lr = false;
               });
         }, 200),


         postingLR() {


            if (Object.values(this.formLRA_stat).includes('CL02') || Object.values(this.formLRA_stat).includes('CL06')) {
               this.api.post_lr = false;
               Swal.fire({
                  icon: 'warning',
                  title: 'Reminder',
                  html: '<span class="fs-18">Please sign and upload all required document/s before submitting</span>',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  confirmButtonText: 'Ok',
               })
            } else {
               this.api.post_lr = true;
               this.formLRA_stat.post('api/lr-post-data')
                  .then(response => {
                     this.api.post_lr = false;

                     Swal.fire({
                        icon: 'success',
                        title: 'Thank You!',
                        html: '<div class="text-justify fs-16"><span>The required loan release documents have been successfully uploaded in the SBCorp Portal.</span><br><br>' +
                           '<span>A Loan Release Officer will verify these documents for completeness and clarity of the signatures and documents, and will send you a notification through an email.</span>' +
                           '<br><br><span>Upon clicking "Ok", the system will log you out.</span',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        allowEnterKey: false,
                        confirmButtonText: 'Ok',
                     }).then((result) => {
                        if (result) {
                           // this.getLoanRelease();
                           axios.post('/logout').then(response => {
                              window.location.href = "/login";
                           }).catch(error => {

                           });
                        }
                     })
                  }).catch(error => {
                     this.api.post_lr = false;
                     console.log(error);
                  })
            }
         },

         startUpload: async function(event) {
            this.res_arr.splice(0, this.res_arr.length);
            this.formLRA.application_id = this.formLR.application_id;
            this.formLRA.borrower_id = this.formLR.borrower_id;
            this.formLRA.account_code = this.formLR.account_code;
            let arr = ['LRA05', 'LRA06', 'LRA08', 'LRA09'];
            for (let key in arr) {
               let val = arr[key];
               if (this.formLRA[val]) {

                  this.api[val] = true;

                  let url = '/api/attach' + val;
                  const config = {
                     headers: {
                        'content-type': 'multipart/form-data',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                     },
                     onUploadProgress: function(progressEvent) {
                        this.progress[val] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                     }.bind(this)

                  }
                  let formData = new FormData();
                  formData.append('application_id', this.formLRA.application_id);
                  formData.append('account_code', this.formLRA.account_code);
                  formData.append('borrower_id', this.formLRA.borrower_id);
                  formData.append(val, this.formLRA[val]);


                  await axios.post(url, formData, config)
                     .then(response => {
                        let data = response.data;

                        if (response.status == 200) {
                           this.formLRA_stat[val] = data.status;
                           this.formLRA[val] = '';
                           document.getElementById(val).value = '';
                           this.fetchLRA_signed[val] = data[val];
                        }
                        this.api[val] = false;
                        this.res_arr.push(response.status);
                     })
                     .catch(error => {
                        this.api[val] = false;
                        this.formLRA_stat[val] = 'CL06';
                        this.formLRA[val] = '';
                        document.getElementById(val).value = '';
                        this.res_arr.push(error.response.status);
                     })
               }
            }
            this.postingLR();
         },


         syncPostLR: async function(event) {
            await this.startUpload();
         },

         postLR: _.debounce(function() {

            this.formLRA_stat.borrower_id = this.formLR.borrower_id;

            if (Object.values(this.formLRA_stat).includes('CL03') || Object.values(this.formLRA_stat).includes('CL09')) {
               Swal.fire({
                  icon: 'warning',
                  title: 'Reminder',
                  html: '<span class="fs-18">Please sign all required document/s before submitting</span>',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  confirmButtonText: 'Ok',
               })
            } else {
               if (this.formLR.lr_status == 'LR09') {
                  // if (this.formNotice.approved_loan_amt >= 150000) {
                  if (this.isPDC) {
                     this.formLRA_stat.lr_status = 'LR12'
                  } else {
                     if (this.formLR.bt_code != "BT2020001") {
                        this.formLRA_stat.lr_status = 'LR12'
                     } else {
                        this.formLRA_stat.lr_status = 'LR03'
                     }
                  }
               }
               if (this.formLR.lr_status == 'LR10') {
                  this.formLRA_stat.lr_status = 'LR11'
               }
               if (this.formLRA_stat.lr_status) {
                  this.syncPostLR();
               }
            }
         }, 200),

         viewFileATT(fileURL) {
            let winFeatures = "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes";
            let win = window.open(fileURL, '', winFeatures);
         },

         viewSelectedFile(file, enclosure_title) {

            if (file['type'] == 'application/pdf') {
               let win = open('', '', "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes");
               let iframe = document.createElement('iframe');
               let title = document.createElement('title');
               let fileUrl = window.URL.createObjectURL(file);

               title.appendChild(document.createTextNode(enclosure_title));

               iframe.src = fileUrl;
               iframe.width = '100%';
               iframe.height = '100%';
               iframe.style.border = 'none';

               win.document.head.appendChild(title);
               win.document.body.appendChild(iframe);
               win.document.body.style.margin = 0;
            } else {
               let fileURL = window.URL.createObjectURL(file);
               let winFeatures = "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes";

               let win = window.open(fileURL, enclosure_title, winFeatures);

               win.onload = (event) => {
                  setTimeout(() => win.document.title = enclosure_title, 500);
               };
            }


         },


         viewFileLRA(fileURL) {
            let winFeatures = "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes";
            let win = window.open(fileURL, '', winFeatures);
         },
         invalidFileFormat() {
            Swal.fire({
               icon: 'warning',
               title: 'Error',
               text: 'You are uploading unsupported file format',
               allowEscapeKey: false,
               allowOutsideClick: false,
            })
         },

         invalidFileSize() {
            Swal.fire({
               icon: 'warning',
               title: 'Info',
               text: 'Exceeded the maximum file size required',
               allowEscapeKey: false,
               allowOutsideClick: false,
            })
         },

         uploadLRA($event, key) {
            this.fetchLRA[key] = '';
            this.fetchLRA_signed[key] = "";
            let file = $event.target.files[0];
            if (file) {
               if (this.filePDF.includes(file['type'])) {
                  if (file['size'] > this.max_size_doc) {
                     this.invalidFileSize();
                     this.formLRA[key] = '';
                     document.getElementById(key).value = '';
                  } else {
                     this.formLRA[key] = file;
                     this.formLRA_stat[key] = 'CL02'
                  }
               } else {
                  this.invalidFileFormat();
                  this.formLRA[key] = '';
                  document.getElementById(key).value = '';
               }
            }
         },


         uploadLRA05(e) {
            this.fetchLRA.LRA05 = '';
            this.fetchLRA_signed.LRA05 = "";
            let file = e.target.files[0];

            if (file) {
               if (this.filePDF.includes(file['type'])) {
                  if (file['size'] > this.max_size_doc) {
                     this.invalidFileSize();
                     this.formLRA.LRA05 = '';
                     document.getElementById('LRA05').value = '';
                  } else {
                     this.formLRA.LRA05 = file;
                  }
               } else {
                  this.invalidFileFormat();
                  this.formLRA.LRA05 = '';
                  document.getElementById('LRA05').value = '';
               }
            }
         },
         viewLRA05() {
            if (this.formLRA.LRA05) {
               let file = this.formLRA.LRA05;
               let enclosure_title = "Borrower's Picture holding his/her 2 government-issued IDs";
               this.viewSelectedFile(file, enclosure_title);
            }
         },
         removeLRA05() {
            this.formLRA.LRA05 = '';
            this.fetchLRA_signed.LRA05 = "";
            document.getElementById('LRA05').value = '';
         },

         uploadLRA06(e) {
            this.fetchLRA.LRA06 = '';
            this.fetchLRA_signed.LRA06 = "";
            this.formLRA.LRA06 = e.target.files[0];
            let file = this.formLRA.LRA06
            if (file && !this.filePDF.includes(file['type'])) {
               this.invalidFileFormat();
               this.formLRA.LRA06 = '';
               document.getElementById('LRA06').value = '';
            }
         },
         viewLRA06() {
            if (this.formLRA.LRA06) {
               let file = this.formLRA.LRA06;
               let enclosure_title = "Notarized Secretary's Certificate and Board Resolution";
               this.viewSelectedFile(file, enclosure_title);
            }
         },
         removeLRA06() {
            this.formLRA.LRA06 = '';
            this.fetchLRA_signed.LRA06 = "";
            document.getElementById('LRA06').value = '';
         },


         uploadLRA08(e) {
            this.fetchLRA.LRA08 = '';
            this.fetchLRA_signed.LRA08 = "";
            this.formLRA.LRA08 = e.target.files[0];
            let file = this.formLRA.LRA08
            if (file && !this.filePDF.includes(file['type'])) {
               this.invalidFileFormat();
               this.formLRA.LRA08 = '';
               document.getElementById('LRA08').value = '';
            }
         },
         viewLRA08() {
            if (this.formLRA.LRA08) {
               let file = this.formLRA.LRA08;
               let enclosure_title = "Picture of Signing of Release Documents by Applicant";
               this.viewSelectedFile(file, enclosure_title);
            }
         },
         removeLRA08() {
            this.formLRA.LRA08 = '';
            this.fetchLRA_signed.LRA08 = "";
            document.getElementById('LRA08').value = '';
         },

         uploadLRA09(e) {
            this.fetchLRA.LRA09 = '';
            this.fetchLRA_signed.LRA09 = "";
            this.formLRA.LRA09 = e.target.files[0];
            let file = this.formLRA.LRA09
            if (file && !this.filePDF.includes(file['type'])) {
               this.invalidFileFormat();
               this.formLRA.LRA09 = '';
               document.getElementById('LRA09').value = '';
            }
         },
         viewLRA09() {
            if (this.formLRA.LRA09) {
               let file = this.formLRA.LRA09;
               let enclosure_title = "Post-Dated Check";
               this.viewSelectedFile(file, enclosure_title);
            }
         },
         removeLRA09() {
            this.formLRA.LRA09 = '';
            this.fetchLRA_signed.LRA09 = "";
            document.getElementById('LRA09').value = '';
         },



         completeLRA01() {
            this.api.complete_lra01 = true;
            axios.post('api/lr-update-lra01', {
                  borrower_id: this.formLR.borrower_id,
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  attach: 'LRA01',
               })
               .then(response => {
                  this.api.complete_lra01 = false;
                  toast.fire({
                     icon: 'success',
                     text: 'Successfully Signed the Document'
                  })

                  this.getSignedLRA();
                  this.routeBack();
                  this.formLRA_stat.LRA01 = 'CL07';

               }).catch(error => {
                  this.api.complete_lra01 = false;
                  console.log(error);
               })
         },

         completeLRA11() {
            this.api.complete_lra01 = true;
            axios.post('api/lr-update-lra11', {
                  borrower_id: this.formLR.borrower_id,
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  attach: 'LRA07',
               })
               .then(response => {
                  this.api.complete_lra01 = false;
                  toast.fire({
                     icon: 'success',
                     text: 'Successfully Signed the Document'
                  })

                  this.getSignedLRA();
                  this.routeBack();
                  this.formLRA_stat.LRA07 = 'CL07';

               }).catch(error => {
                  this.api.complete_lra01 = false;
                  console.log(error);
               })
         },


         completeLRA02() {
            this.api.complete_lra02 = true;
            axios.post('api/lr-update-lra02', {
                  borrower_id: this.formLR.borrower_id,
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  attach: 'LRA02',
               })
               .then(response => {
                  this.api.complete_lra02 = false;
                  toast.fire({
                     icon: 'success',
                     text: 'Successfully Signed the Document'
                  })

                  this.getSignedLRA();
                  this.routeBack();
                  this.formLRA_stat.LRA02 = 'CL07';

               }).catch(error => {
                  this.api.complete_lra02 = false;
                  console.log(error);
               })
         },
         completeLRA04() {
            this.api.complete_lra04 = true;
            axios.post('api/lr-update-lra04', {
                  borrower_id: this.formLR.borrower_id,
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  attach: 'LRA03',
               })
               .then(response => {
                  this.api.complete_lra04 = false;
                  toast.fire({
                     icon: 'success',
                     text: 'Successfully Signed the Document'
                  })

                  this.getSignedLRA();
                  this.routeBack();
                  this.formLRA_stat.LRA03 = 'CL07';

               }).catch(error => {
                  this.api.complete_lra04 = false;
                  console.log(error);
               })
         },

         completeLRA03() {
            this.api.complete_lra03 = true;
            axios.post('api/lr-update-lra03', {
                  borrower_id: this.formLR.borrower_id,
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  attach: 'LRA03',
               })
               .then(response => {
                  this.api.complete_lra03 = false;
                  toast.fire({
                     icon: 'success',
                     text: 'Successfully Signed the Document'
                  })

                  this.getSignedLRA();
                  this.routeBack();
                  this.formLRA_stat.LRA03 = 'CL07';

               }).catch(error => {
                  this.api.complete_lra03 = false;
                  console.log(error);
               })
         },

         completeLRA07() {
            this.api.complete_lra07 = true;
            axios.post('api/lr-update-lra07', {
                  borrower_id: this.formLR.borrower_id,
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  attach: 'LRA04',
               })
               .then(response => {
                  this.api.complete_lra07 = false;
                  toast.fire({
                     icon: 'success',
                     text: 'Successfully Signed the Document'
                  })

                  this.getSignedLRA();
                  this.routeBack();
                  this.formLRA_stat.LRA04 = 'CL07';

               }).catch(error => {
                  this.api.complete_lra07 = false;
                  console.log(error);
               })
         },

         getSignedLRA() {
            this.api.attachment = true;
            axios.get('api/lr-attachments-signed', {
                  params: {
                     application_id: this.formLR.application_id,
                     borrower_id: this.formLR.borrower_id,
                     account_code: this.formLR.account_code
                  }
               })
               .then(response => {
                  if (response.data.length > 0) {
                     this.fetchLRA_signed.fill(response.data[0])
                  }
                  this.api.attachment = false;

               })
               .catch(error => {
                  this.api.attachment = false;
                  console.log(error)
               })
         },


         generatePDFNoticeSig() {
            this.api.loan_release00 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;


            setTimeout(() => {
               this.formPDF.post('api/lr-generate-pdfnoticesig')
                  .then(response => {
                     $('#generateOTP').modal('hide');
                     this.api.loan_release00 = false;
                     this.getLoanRelease();
                     this.getSignedLRA();
                  }).catch(error => {
                     this.api.loan_release00 = false;
                     console.log(error);
                  })

            }, 500)
         },


         getLoanReleaseLRA00() {
            this.api.loan_release000 = true;

            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;

            axios.get('/api/lr-details', {
                  params: {
                     application_id: this.routeApp
                  }
               })
               .then(response => {
                  this.api.loan_release000 = false;
                  if (response.data.length > 0) {
                     this.formLR.fill(response.data[0]);
                     if (this.formLR.otp) {
                        this.generatePDFNoticeSig();
                     }
                  }
               })
               .catch(error => {
                  this.api.loan_release000 = false;
                  console.log(error);
               })

         },

         generatePDFNotice() {
            // this.signingLRA01 = true;

            let aw_approved_loan_amt = this.amountWords(this.formNotice.approved_loan_amt);
            let aw_first_due_amt = this.amountWords(this.formNotice.first_due_amt);

            this.api.loan_release = true;
            axios.post('api/lr-generate-pdfnotice', {
                  application_id: this.formLR.application_id,
                  borrower_id: this.formLR.borrower_id,
                  account_code: this.formLR.account_code,
                  aw_approved_loan_amt: aw_approved_loan_amt,
                  aw_first_due_amt: aw_first_due_amt

               })
               .then(response => {
                  // this.api.signingLRA01 = false;
                  this.api.loan_release = false;
                  this.formPDF.pathAttach = response.data.path;
                  this.formPDF.fileAttach = response.data.filename;

                  this.getLoanReleaseLRA00();

               }).catch(error => {
                  // this.api.signingLRA01 = false;
                  this.api.loan_release = false;
                  console.log(error);
               })




         },


         generatePDFNoticeCo() {
            // this.signingLRA01 = true;
            let aw_approved_loan_amt = this.amountWords(this.formNotice.approved_loan_amt);
            let aw_first_due_amt = this.amountWords(this.formNotice.first_due_amt);

            this.api.loan_release = true;
            axios.post('api/lr-generate-pdfnoticeco', {
                  application_id: this.formLR.application_id,
                  borrower_id: this.formLR.borrower_id,
                  account_code: this.formLR.account_code,
                  aw_approved_loan_amt: aw_approved_loan_amt,
                  aw_first_due_amt: aw_first_due_amt
               })
               .then(response => {
                  // this.api.signingLRA01 = false;
                  this.api.loan_release = false;
                  this.formPDF.pathAttach = response.data.path;
                  this.formPDF.fileAttach = response.data.filename;

                  this.getLoanReleaseLRA00();
               }).catch(error => {
                  // this.api.signingLRA01 = false;
                  this.api.loan_release = false;
                  console.log(error);
               })




         },
         generateLRA01_Sblaf() {
            this.api.signingLRA01 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA01;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;
            this.formPDF.bt_code = this.formLR.bt_code;

            this.formPDF.post('api/lr-generate-pdflra01-sblaf', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA01 = false;

                  this.downloadLRA01 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA01();

               }).catch(error => {
                  this.api.signingLRA01 = false;
                  console.log(error);
               })
         },
         signLoanApp(e) {
            const normalizeDate = (dateString) => {
               const d = new Date(dateString);
               d.setHours(0, 0, 0, 0);
               return d;
            };

            const createdAt = normalizeDate(this.formLRA_stat.created_at);
            const cutoffDate = normalizeDate('2025-07-01');

            const applicationDate = normalizeDate(this.fetchLRA.application_date);
            const targetDate = normalizeDate('2025-01-16');

            switch (e) {
               case 'FIB07':
                  this.generateLRA01_13();
                  break;
               case 'FIB10':
               case 'FIB11':
               case 'FIB14':
               case 'FIB12':
               case 'FIB13':
               case 'FIB15':
               case 'FIB16':
                  if (applicationDate < targetDate) {
                     this.generateLRA01_RiseUp();
                  } else {
                     cutoffDate < createdAt ? this.generateLRA01_Sblaf() : this.generateLRA01_RiseUp();
                  }
                  break;
               case 'FIB01':
               case 'FIB02':
               case 'FIB03':
               case 'FIB06':
               case 'FIB09':
                  this.generateLRA01();
                  break;

               case 'FIB08':
               case 'FIB17':
                  this.generateLRA01_Sblaf();
                  break;
               default:
                  alert('Unable to process');
            }
         },
         generatePDFLRA01: _.debounce(function() {
            this.signingLRA01 = true;

            if (this.formLR.coborrower_id || this.formLRA_stat.co_signatory) {
               if (this.signingLRA01 && !this.sigLRA01.sig01 || !this.sigLRA01.sig02 || !this.sigLRA01.sig03 || !this.sigLRA01.sig04 || !this.sigLRA01.sig05 || !this.sigLRA01.sig06 || !this.sigLRA01.sig07 || !this.sigLRA01.sig08) {
                  this.signAllRequired();
               } else {

                  this.signLoanApp(this.formLR.loan_bus_code);

                  // if (this.formLR.loan_bus_code == 'FIB07') {
                  //    this.generateLRA01_13();
                  // } else if (this.formLR.loan_bus_code == 'FIB08') {
                  //    this.generateLRA01_Odette();
                  // } else {
                  //    this.generateLRA01();
                  // }
               }
            } else {
               if (this.signingLRA01 && !this.sigLRA01.sig01 || !this.sigLRA01.sig02 || !this.sigLRA01.sig03 || !this.sigLRA01.sig04) {
                  this.signAllRequired();
               } else {

                  this.signLoanApp(this.formLR.loan_bus_code);

                  // if (this.formLR.loan_bus_code == 'FIB07') {
                  //    this.generateLRA01_13();
                  // } else if (this.formLR.loan_bus_code == 'FIB08') {
                  //    this.generateLRA01_Odette();
                  // } else {
                  //    this.generateLRA01();
                  // }
               }
            }


         }, 200),




         generatePDFLRA11: _.debounce(function() {
            this.signingLRA01 = true;
            if (this.signingLRA11 && !this.sigLRA11.sig01) {
               this.signAllRequired();
            } else {
               this.generateLRA11();
            }
         }, 200),

         signAllRequired() {
            Swal.fire({
               html: `<span class="fs-22 bold">Please sign all required pages</span>`,
               icon: 'info',
               allowEscapeKey: false,
               allowOutsideClick: false,
               allowEnterKey: false,
               confirmButtonText: 'Ok',
            })
         },


         generateLRA01_RiseUp() {
            this.api.signingLRA01 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA01;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra01-riseup', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA01 = false;

                  this.downloadLRA01 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA01();

               }).catch(error => {
                  this.api.signingLRA01 = false;
                  console.log(error);
               })
         },

         generateLRA01_Odette() {
            this.api.signingLRA01 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA01;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra01-odette', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA01 = false;

                  this.downloadLRA01 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA01();

               }).catch(error => {
                  this.api.signingLRA01 = false;
                  console.log(error);
               })
         },

         generateLRA01_13() {
            this.api.signingLRA01 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA01;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra01-13', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA01 = false;

                  this.downloadLRA01 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA01();

               }).catch(error => {
                  this.api.signingLRA01 = false;
                  console.log(error);
               })
         },

         generateLRA01() {
            this.api.signingLRA01 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA01;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra01', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA01 = false;

                  this.downloadLRA01 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA01();

               }).catch(error => {
                  this.api.signingLRA01 = false;
                  console.log(error);
               })
         },


         generateLRA11() {
            this.api.signingLRA01 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA07;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;

            this.formPDF.post('api/lr-generate-pdflra11', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA01 = false;

                  this.downloadLRA01 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA11();

               }).catch(error => {
                  this.api.signingLRA01 = false;
                  console.log(error);
               })
         },

         generateLRA02() {
            this.api.signingLRA02 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA02;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra02', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA02 = false;

                  this.downloadLRA02 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA02();

               }).catch(error => {
                  this.api.signingLRA02 = true;
                  console.log(error);
               })
         },


         generateLRA02_Odette() {
            this.api.signingLRA02 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA02;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra02-odette', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA02 = false;

                  this.downloadLRA02 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA02();

               }).catch(error => {
                  this.api.signingLRA02 = true;
                  console.log(error);
               })
         },

         generateLRA02_RiseUp() {
            this.api.signingLRA02 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA02;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra02-riseup', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA02 = false;

                  this.downloadLRA02 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA02();

               }).catch(error => {
                  this.api.signingLRA02 = true;
                  console.log(error);
               })
         },



         generateLRA02_13() {
            this.api.signingLRA02 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA02;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;

            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra02-13', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA02 = false;

                  this.downloadLRA02 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA02();

               }).catch(error => {
                  this.api.signingLRA02 = true;
                  console.log(error);
               })
         },
         generateLRA04_Odette() {
            this.api.signingLRA04 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA03;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;
            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra04-odette', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA04 = false;
                  this.downloadLRA04 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA04();
               }).catch(error => {
                  this.api.signingLRA04 = false;
                  console.log(error);
               })
         },
         generateLRA04() {
            this.api.signingLRA04 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA03;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;
            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra04', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA04 = false;
                  this.downloadLRA04 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA04();

               }).catch(error => {
                  this.api.signingLRA04 = false;
                  console.log(error);
               })
         },

         signPN(e) {
            switch (e) {
               case 'FIB07':
                  this.generateLRA02_13();
                  break;
               case 'FIB08':
                  this.generateLRA02_Odette();
                  break;
               case 'FIB10':
               case 'FIB11':
               case 'FIB14':
               case 'FIB12':
               case 'FIB13':
               case 'FIB15':
               case 'FIB16':
                  // ERF
               case 'FIB17':
                  this.generateLRA02_RiseUp();
                  break;
               case 'FIB01':
               case 'FIB02':
               case 'FIB03':
               case 'FIB06':
               case 'FIB09':
                  this.generateLRA02();
                  break;
               default:
                  alert('Unable to process');
            }
         },

         generatePDFLRA02: _.debounce(function() {
            this.signingLRA02 = true;
            if (this.formLR.coborrower_id || this.formLRA_stat.co_signatory) {
               if (this.signingLRA02 && !this.sigLRA02.sig01 || !this.sigLRA02.sig02) {
                  this.signAllRequired();
               } else {
                  this.signPN(this.formLR.loan_bus_code);
               }
            } else {
               if (this.signingLRA02 && !this.sigLRA02.sig01) {
                  this.signAllRequired();
               } else {
                  this.signPN(this.formLR.loan_bus_code);
               }
            }
         }, 200),

         generatePDFLRA03: _.debounce(function() {
            this.signingLRA03 = true;
            if (this.signingLRA03 && !this.sigLRA03.sig01) {
               Swal.fire({
                  html: `<span class="fs-22 bold">Please sign all required pages</span>`,
                  icon: 'info',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  confirmButtonText: 'Ok',
               })
            } else {
               this.api.signingLRA03 = true;
               this.formPDF.borrower_id = this.formLR.borrower_id;
               this.formPDF.application_id = this.formLR.application_id;
               this.formPDF.account_code = this.formLR.account_code;
               this.formPDF.otp = this.formLR.otp;
               this.formPDF.pathAttach = this.fetchLRA.filepath;
               this.formPDF.fileAttach = this.fetchLRA.LRA03;
               this.formPDF.pathSIG = this.formLR.filepath;
               this.formPDF.fileSIG01 = this.formLR.SIG01;

               this.formPDF.post('api/lr-generate-pdflra03', {
                     responseType: 'blob'
                  })
                  .then(response => {
                     this.api.signingLRA03 = false;
                     this.downloadLRA03 = response.data;
                     // this.fetchLRA.reset();
                     this.completeLRA03();

                  }).catch(error => {
                     this.api.signingLRA03 = false;
                     console.log(error);
                  })
            }


         }, 200),

         generatePDFLRA04: _.debounce(function() {
            this.signingLRA04 = true;

            if (this.formLR.coborrower_id || this.formLRA_stat.co_signatory) {
               if (this.signingLRA04 && !this.sigLRA04.sig01 || !this.sigLRA04.sig02) {
                  this.signAllRequired();
               } else {

                  if (this.formLR.loan_bus_code == 'FIB08') {
                     this.generateLRA04_Odette();
                  } else {
                     this.generateLRA04();
                  }

               }
            } else {
               if (this.signingLRA04 && !this.sigLRA04.sig01) {
                  this.signAllRequired();
               } else {
                  if (this.formLR.loan_bus_code == 'FIB08') {
                     this.generateLRA04_Odette();
                  } else {
                     this.generateLRA04();
                  }
               }
            }
         }, 200),

         signLoanAgreement(e) {
            switch (e) {
               case 'FIB08':
                  this.generateLRA07_Odette();
                  break;
               case 'FIB10':
               case 'FIB11':
               case 'FIB14':
               case 'FIB12':
               case 'FIB13':
               case 'FIB15':
               case 'FIB16':
                  // ERF
               case 'FIB17':
                  this.generateLRA07_RiseUp();
                  break;
               case 'FIB01':
               case 'FIB02':
               case 'FIB03':
               case 'FIB06':
               case 'FIB09':
                  this.generateLRA07();
                  break;
               default:
                  alert('Unable to process');
            }
         },

         generatePDFLRA07: _.debounce(function() {
            this.signingLRA07 = true;

            if (this.formLR.coborrower_id || this.formLRA_stat.co_signatory) {
               if (this.signingLRA07 && !this.sigLRA07.sig01 || !this.sigLRA07.sig02) {
                  this.signAllRequired();
               } else {
                  this.signLoanAgreement(this.formLR.loan_bus_code);
               }
            } else {
               if (this.signingLRA07 && !this.sigLRA07.sig01) {
                  this.signAllRequired();
               } else {
                  this.signLoanAgreement(this.formLR.loan_bus_code);
               }
            }
         }, 200),


         generateLRA07_RiseUp() {
            this.api.signingLRA07 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA04;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;
            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra07-riseup', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA07 = false;
                  this.downloadLRA07 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA07();

               }).catch(error => {
                  this.api.signingLRA07 = false;
                  console.log(error);
               })

         },

         generateLRA07_Odette() {
            this.api.signingLRA07 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA04;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;
            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            this.formPDF.post('api/lr-generate-pdflra07-odette', {
                  responseType: 'blob'
               })
               .then(response => {
                  this.api.signingLRA07 = false;
                  this.downloadLRA07 = response.data;
                  // this.fetchLRA.reset();
                  this.completeLRA07();

               }).catch(error => {
                  this.api.signingLRA07 = false;
                  console.log(error);
               })

         },

         generateLRA07() {
            this.api.signingLRA07 = true;
            this.formPDF.borrower_id = this.formLR.borrower_id;
            this.formPDF.application_id = this.formLR.application_id;
            this.formPDF.account_code = this.formLR.account_code;
            this.formPDF.otp = this.formLR.otp;
            this.formPDF.pathAttach = this.fetchLRA.filepath;
            this.formPDF.fileAttach = this.fetchLRA.LRA04;
            this.formPDF.pathSIG = this.formLR.filepath;
            this.formPDF.fileSIG01 = this.formLR.SIG01;
            this.formPDF.fileSIG02 = this.formLR.SIG02;
            this.formPDF.coborrower_id = this.formLR.coborrower_id;
            this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

            if (this.formLR.loan_bus_code == 'FIB07') {
               this.formPDF.post('api/lr-generate-pdflra07-13', {
                     responseType: 'blob'
                  })
                  .then(response => {
                     this.api.signingLRA07 = false;
                     this.downloadLRA07 = response.data;
                     this.completeLRA07();

                  }).catch(error => {
                     this.api.signingLRA07 = false;
                     console.log(error);
                  })
            } else {
               this.formPDF.post('api/lr-generate-pdflra07', {
                     responseType: 'blob'
                  })
                  .then(response => {
                     this.api.signingLRA07 = false;
                     this.downloadLRA07 = response.data;
                     // this.fetchLRA.reset();
                     this.completeLRA07();

                  }).catch(error => {
                     this.api.signingLRA07 = false;
                     console.log(error);
                  })
            }


         },


         // generateLRA07: _.debounce(function() {
         //    this.signingLRA07 = true;
         //    if (this.signingLRA07 && !this.sigLRA07.sig01) {
         //       Swal.fire({
         //          html: `<span class="fs-22 bold">Please sign all required pages</span>`,
         //          icon: 'info',
         //          allowEscapeKey: false,
         //          allowOutsideClick: false,
         //          allowEnterKey: false,
         //          confirmButtonText: 'Ok',
         //       })
         //    } else {
         //       this.api.signingLRA07 = true;
         //       this.formPDF.borrower_id = this.formLR.borrower_id;
         //       this.formPDF.application_id = this.formLR.application_id;
         //       this.formPDF.otp = this.formLR.otp;
         //       this.formPDF.pathAttach = this.fetchLRA.filepath;
         //       this.formPDF.fileAttach = this.fetchLRA.LRA04;
         //       this.formPDF.pathSIG = this.formLR.filepath;
         //       this.formPDF.fileSIG01 = this.formLR.SIG01;
         //       this.formPDF.fileSIG02 = this.formLR.SIG02;
         //       this.formPDF.coborrower_id = this.formLR.coborrower_id;
         //       this.formPDF.co_signatory = this.formLRA_stat.co_signatory;

         //       this.formPDF.post('api/lr-generate-pdflra07', {
         //             responseType: 'blob'
         //          })
         //          .then(response => {
         //             this.api.signingLRA07 = false;
         //             this.downloadLRA07 = response.data;
         //             // this.fetchLRA.reset();
         //             this.completeLRA07();

         //          }).catch(error => {
         //             this.api.signingLRA07 = false;
         //             console.log(error);
         //          })
         //    }


         // }, 200),


         generateOTP: _.debounce(function() {
            const {
               isEmpty,
               data
            } = this.$refs.signaturePad.saveSignature();


            this.formLR.isEmpty = isEmpty;


            this.generating = true;
            this.$v.iAgreeChecked.$touch();
            if (this.$v.iAgreeChecked.$invalid) {
               Swal.fire({
                  html: `<span class="fs-22 bold">Please fill-out all required fields</span>`,
                  icon: 'info',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  confirmButtonText: 'Ok',
               })
            } else {
               const {
                  isEmpty,
                  data
               } = this.$refs.cosignaturePad.saveSignature();
               this.formLR.isEmptyCo = isEmpty;

               if (this.formLR.coborrower_id) {
                  if (this.formLR.isEmpty || this.formLR.isEmptyCo) {
                     Swal.fire({
                        html: `<span class="fs-22 bold">Please sign the document before submitting</span>`,
                        icon: 'info',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        allowEnterKey: false,
                        confirmButtonText: 'Ok',
                     })
                  } else {
                     if (this.formOTP.sent) {
                        $('#generateOTP').modal('show');
                     } else {
                        this.api.generate_otp = true;
                        this.formLR.post('api/lr-generate-otp')
                           .then(response => {
                              this.api.generate_otp = false;
                              let data = response.data;
                              this.counting = true;
                              this.formLR.session_id = data.session_id;
                              $('#generateOTP').modal('show');
                           }).catch(error => {
                              this.api.generate_otp = false;
                              console.log(error);
                           })
                     }
                  }
               } else {
                  if (this.formLR.isEmpty) {
                     Swal.fire({
                        html: `<span class="fs-22 bold">Please sign the document before submitting</span>`,
                        icon: 'info',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        allowEnterKey: false,
                        confirmButtonText: 'Ok',
                     })
                  } else {

                     if (this.formOTP.sent) {
                        $('#generateOTP').modal('show');
                     } else {
                        this.api.generate_otp = true;
                        this.formLR.post('api/lr-generate-otp')
                           .then(response => {
                              let data = response.data;
                              this.api.generate_otp = false;
                              this.formOTP.sent = true;
                              this.counting = true;
                              this.formLR.session_id = data.session_id;
                              $('#generateOTP').modal('show');
                           }).catch(error => {
                              this.api.generate_otp = false;
                              console.log(error);
                           })
                     }
                  }

               }
            }

         }, 200),



         showSign() {
            this.isSigned = true;


         },
         clearSign() {
            this.$refs.signaturePad.clearSignature()
         },
         clearSignCo() {
            this.$refs.cosignaturePad.clearSignature()
         },
         postAcceptance: _.debounce(function() {
            this.formLR.co_signatory = this.formLRA_stat.co_signatory;
            const {
               isEmpty,
               data
            } = this.$refs.signaturePad.saveSignature();
            this.formLR.isEmpty = isEmpty;
            this.formLR.SIG01 = data;
            this.generatingOTP = true;
            this.$v.formOTP.$touch();
            if (this.$v.formOTP.$invalid) {
               Swal.fire({
                  html: `<span class="fs-22 bold">Please fill-out all required fields</span>`,
                  icon: 'info',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  confirmButtonText: 'Ok',
               })
            } else {

               const {
                  isEmpty,
                  data
               } = this.$refs.cosignaturePad.saveSignature();
               // alert("Open DevTools see the save data.");

               this.formLR.isEmptyCo = isEmpty;
               this.formLR.SIG02 = data;
               // this.formLR.verification_code = this.concatOTP

               this.formLR.verification_code = this.formOTP.code;
               this.api.post_acceptance = true;
               this.formLR.post('api/lr-bor-acceptance')
                  .then(response => {
                     this.api.post_acceptance = false;
                     let data = response.data.status;
                     if (data == 0) {
                        this.formOTP.invalid = true;
                     } else {
                        this.$refs.signaturePad.clearSignature()
                        this.$refs.cosignaturePad.clearSignature()
                        if (!this.formLR.isEmpty && !this.formLR.isEmptyCo) {
                           this.generatePDFNoticeCo();
                        } else {
                           this.generatePDFNotice();
                        }
                     }
                  }).catch(error => {
                     this.api.post_acceptance = false;
                     console.log(error);
                  })
            }


         }, 200),

         cancelOTP() {
            $('#generateOTP').modal('hide');
            this.formOTP.reset();
         },

         routeBack() {
            this.isHiddenPDF = false;
            this.isHiddenMain = true;
            this.signingLRA01 = false;
            this.signingLRA02 = false;
            this.signingLRA04 = false;

            this.signingLRA11 = false;
            this.$router.push('/loan-releasing?app=' + this.routeApp);
         },

         getLRAttachments() {
            this.api.attachment = true;
            axios.get('api/lr-attachments', {
                  params: {
                     application_id: this.formLR.application_id,
                     borrower_id: this.formLR.borrower_id,
                     account_code: this.formLR.account_code
                  }
               })
               .then(response => {
                  if (response.data.length > 0) {
                     this.fetchLRA.fill(response.data[0])
                  }
                  this.api.attachment = false;

               })
               .catch(error => {
                  this.api.attachment = false;
                  console.log(error)
               })
         },
         undo() {
            this.$refs.signaturePad.undoSignature();
         },
         undoCo() {
            this.$refs.cosignaturePad.undoSignature();
         },

         otp(e) {
            if (e == 1) {
               this.formOTP.otp1 ? this.$refs.otp2.focus() : this.$refs.otp1.focus();
            }
            if (e == 2) {
               this.formOTP.otp2 ? this.$refs.otp3.focus() : this.$refs.otp2.focus();
            }
            if (e == 3) {
               this.formOTP.otp3 ? this.$refs.otp4.focus() : this.$refs.otp3.focus();
            }
            if (e == 4) {
               this.formOTP.otp4 ? this.$refs.otp5.focus() : this.$refs.otp4.focus();
            }
            if (e == 5) {
               this.formOTP.otp5 ? this.$refs.otp6.focus() : this.$refs.otp5.focus();
            }
            if (e == 6) {
               this.formOTP.otp6 ? this.$refs.otpSubmit.focus() : this.$refs.otp6.focus();
            }
         },
         delotp(e) {
            if (e == 1) {
               this.$refs.otp1.focus();
            }
            if (e == 2) {
               this.$refs.otp1.focus();
            }
            if (e == 3) {
               this.$refs.otp2.focus();
            }
            if (e == 4) {
               this.$refs.otp3.focus();
            }
            if (e == 5) {
               this.$refs.otp4.focus();
            }

            if (e == 6) {
               this.$refs.otp5.focus();
            }
         },


         getKeyByValue(object, value) {
            for (var key in object) {
               if (object.hasOwnProperty(key)) {
                  if (object[key] === value)
                     return key;
               }
            }
         },

         loadAttachment(e, status) {
            this.routeStat = status;

            if (e == 0) {
               if (status == 'CL03' || status == 'CL09') {
                  this.routeFile = this.fetchLRA.LRA00;
                  this.routeKey = this.getKeyByValue(this.fetchLRA, this.routeFile);
               } else {
                  this.routeFile = this.fetchLRA_signed.LRA00;
                  this.routeKey = this.getKeyByValue(this.fetchLRA_signed, this.routeFile);
               }

            }
            if (e == 1) {
               if (status == 'CL03' || status == 'CL09') {
                  this.routeFile = this.fetchLRA.LRA01;
                  this.routeKey = this.getKeyByValue(this.fetchLRA, this.routeFile);
               } else {
                  this.routeFile = this.fetchLRA_signed.LRA01;
                  this.routeKey = this.getKeyByValue(this.fetchLRA_signed, this.routeFile);
               }

            }

            if (e == 2) {
               if (status == 'CL03' || status == 'CL09') {
                  this.routeFile = this.fetchLRA.LRA02;
                  this.routeKey = this.getKeyByValue(this.fetchLRA, this.routeFile);
               } else {
                  this.routeFile = this.fetchLRA_signed.LRA02;
                  this.routeKey = this.getKeyByValue(this.fetchLRA_signed, this.routeFile);
               }

            }

            if (e == 3) {
               if (status == 'CL03' || status == 'CL09') {
                  this.routeFile = this.fetchLRA.LRA03;
                  this.routeKey = this.getKeyByValue(this.fetchLRA, this.routeFile);
               } else {
                  this.routeFile = this.fetchLRA_signed.LRA03;
                  this.routeKey = this.getKeyByValue(this.fetchLRA_signed, this.routeFile);
               }

            }

            if (e == 4) {
               if (status == 'CL03' || status == 'CL09') {
                  this.routeFile = this.fetchLRA.LRA04;
                  this.routeKey = this.getKeyByValue(this.fetchLRA, this.routeFile);
               } else {
                  this.routeFile = this.fetchLRA_signed.LRA04;
                  this.routeKey = this.getKeyByValue(this.fetchLRA_signed, this.routeFile);
               }

            }


            if (e == 11) {
               if (status == 'CL03' || status == 'CL09') {
                  this.routeFile = this.fetchLRA.LRA07;
                  this.routeKey = this.getKeyByValue(this.fetchLRA, this.routeFile);
               } else {
                  this.routeFile = this.fetchLRA_signed.LRA07;
                  this.routeKey = this.getKeyByValue(this.fetchLRA_signed, this.routeFile);
               }

            }

            this.$router.push({
               path: 'loan-releasing?app=' + this.routeApp,
               query: {
                  f: this.routeFile,
                  s: this.routeStat
               }
            });
            this.isHiddenPDF = true;
            this.isHiddenMain = false;
         },

         getLRBorStat() {
            this.api.bor_stat = true;
            axios.get('/api/lr-bor-stat', {
                  params: {
                     application_id: this.formLR.application_id,
                     account_code: this.formLR.account_code
                  }
               })
               .then(response => {
                  this.api.bor_stat = false;
                  this.formLRA_stat.fill(response.data[0])


                  setTimeout(() => {
                     if (!this.formLRA_stat.LRA05) {
                        this.formLRA_stat.LRA05 = "CL02";
                     }

                     if (this.formLR.bt_code != 'BT2020001' && !this.formLRA_stat.LRA06) {
                        this.formLRA_stat.LRA06 = "CL02";
                     }

                     if (!this.formLRA_stat.LRA08) {
                        this.formLRA_stat.LRA08 = "CL02";
                     }

                     // if (this.formNotice.approved_loan_amt >= 150000 && !this.formLRA_stat.LRA09) {
                     if (this.isPDC && !this.formLRA_stat.LRA09) {
                        this.formLRA_stat.LRA09 = "CL02";
                     }
                  }, 200)


               }).catch(error => {
                  this.api.bor_stat = false;
                  console.log(error)
               })
         },

         getNotice() {
            axios.get('api/lr-notice', {
                  params: {
                     account_code: this.formLR.account_code
                  }
               })
               .then(response => {
                  this.formNotice.fill(response.data[0]);

                  setTimeout(() => {

                     if (this.formNotice.manner_rel == 'GC') {
                        this.formNotice.bankname = "GCASH";
                     }

                     this.formLR.bt_code = this.formNotice.bt_code;
                     this.getLRAttachments();
                     this.getSignedLRA();
                     this.getLRBorStat();
                  }, 200)

               })
               .catch(error => {
                  // this.api.loan_release = false;
                  console.log(error);
               })
         },

         insertDateStart() {
            axios.post('/api/lr-date-start', {
                  application_id: this.formLR.application_id,
                  account_code: this.formLR.account_code,
                  borrower_id: this.formLR.borrower_id
               })
               .then(response => {}).catch(error => {

               });
         },

         hashEmail(email) {
            // Split email into username and domain
            const [username, domain] = email.split('@');
            // Calculate the number of asterisks required
            const asterisksCount = username.length - 2;
            // Create a string of asterisks
            const asterisks = '*'.repeat(asterisksCount);
            // Replace a portion of the username with asterisks
            const hashedUsername = username.substring(0, 2) + asterisks;
            // Reconstruct hashed email
            return `${hashedUsername}@${domain}`;
         },

         getLoanRelease() {
            this.api.loan_release = true;
            axios.get('/api/lr-details', {
                  params: {
                     application_id: this.routeApp
                  }
               })
               .then(response => {

                  this.api.loan_release = false;
                  if (response.data.length > 0) {
                     this.formLR.fill(response.data[0]);

                     let number = this.formLR.mobile_number;
                     number = number.replace(/[^\d]/g, '');

                     let new_number = '+63' + number.substring(1);
                     this.formLR.mobile_no = '+63' + number.substring(1);

                     let lastFour = new_number.slice(new_number.length - 4); // => "Tabs1"
                     this.formLR.mobile_no_hash = '*******' + lastFour;

                     this.formLR.email_hash = this.hashEmail(this.formLR.email);
                     this.formLR.otp_type = 'sms';
                     if (!this.formLR.otp) {
                        this.insertDateStart();
                     }


                     this.getNotice();
                  }

               })
               .catch(error => {
                  this.api.loan_release = false;
                  console.log(error);
               })

         },

      },

      created() {
         this.getLoanRelease();



      },


      mounted() {
         let w = window.innerWidth;
         if (w > 768) {
            $('.table-responsive').on('show.bs.dropdown', function() {
               $('.table-responsive').css("overflow", "inherit");
            });

            $('.table-responsive').on('hide.bs.dropdown', function() {
               $('.table-responsive').css("overflow", "auto");
            })
         }
      },

      computed: {
         isPDC() {
            const amount = this.formNotice.approved_loan_amt * 1; // Ensure amount is a number
            const applicationDate = this.fetchLRA.application_date ? new Date(this.fetchLRA.application_date) : null;
            const releaseDate = this.fetchLRA.release_date ? new Date(this.fetchLRA.release_date) : null;
            const cutoffDate = new Date('2024-10-29'); // Static cutoff date
            const deployDate = new Date('2025-03-22'); // Static deployment date

            // Condition 1: If amount is greater than or equal to 150000
            if (amount && amount >= 150000) {
               return true;
            }

            // Condition 2: Check releaseDate, applicationDate, and amount
            if (
               releaseDate && // Ensure releaseDate exists
               releaseDate > deployDate && // Release date must be after deployDate
               applicationDate > cutoffDate && // Application date must be after cutoffDate
               amount && amount > 100000
            ) {
               return true;
            }

            // If none of the conditions are met
            return false;
         },
         processingAPI() {
            if (Object.values(this.api).includes(true)) {
               return true;
            } else {
               return false;
            }
         },
         requiredLA() {
            let req = false;
            let approved_loan_amt = this.formNotice.approved_loan_amt;
            let bt_code = this.formLR.bt_code;
            let loan_bus_code = this.formLR.loan_bus_code;
            let riseup = ['FIB10', 'FIB11', 'FIB12', 'FIB13', 'FIB14', 'FIB15', 'FIB16'];
            let LRA04 = this.formLRA_stat.LRA04;
            if (LRA04) {
               return true;
            }
            if (bt_code != 'BT2020001') {
               return true;
            }
            if (approved_loan_amt > 300000 && bt_code == 'BT2020001' && !riseup.includes(loan_bus_code)) {
               return true;
            }
            if (approved_loan_amt > 1000000 && bt_code == 'BT2020001' && riseup.includes(loan_bus_code)) {
               return true;
            }
            return false;
         },

         initLoad() {
            if (!this.formLR.otp && (this.formLR.lr_status == 'LR09' || this.formLR.lr_status == 'LR10')) {
               return true;
            }
            return false;
         },

         loadDocument() {
            if (this.formLR.otp && this.formLR.SIG01) {
               return true;
            }
            return false;
         },


         desc_LRA00() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA00);
            return data ? data.description : '';
         },


         desc_LRA01() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA01);
            return data ? data.description : '';
         },
         desc_LRA02() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA02);
            return data ? data.description : '';
         },

         desc_LRA03() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA03);
            return data ? data.description : '';
         },

         desc_LRA04() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA04);
            return data ? data.description : '';
         },



         desc_LRA05() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA05);
            return data ? data.description : '';
         },
         desc_LRA06() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA06);
            return data ? data.description : '';
         },
         desc_LRA07() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA07);
            return data ? data.description : '';
         },


         desc_LRA08() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA08);
            return data ? data.description : '';
         },
         desc_LRA09() {
            let data = this.arr_lrv.find(i => i.code === this.formLRA_stat.LRA09);
            return data ? data.description : '';
         },

         label_LRA() {
            let data = this.arr_label.find(i => i.code === this.routeKey);
            return data ? data.label : '';
         },
      }


   }
</script>
<style scoped>
   .dropdown-item:active {
      color: #fff !important;
      background: #007bff !important;

   }

   .dropdown-item {
      cursor: pointer !important;
   }

   .CL02 {
      /* for uploadin */
      color: #fff;
      background-color: #007bff;
   }

   .CL03 {
      /* For signature */
      color: #fff;
      background-color: #007bff;
   }

   .CL07 {
      /* Signed */
      color: #fff;
      background-color: #28a745;
   }

   .CL08 {
      /* Uploaded */
      color: #fff;
      background-color: #28a745;
   }

   .CL04 {
      /* Verified */
      color: #fff;
      background-color: #28a745;
   }

   .CL01 {
      /*  for Verification */
      color: #fff;
      background-color: #28a745;
   }

   .CL09 {
      /* For signature */
      color: #fff;
      background-color: #007bff;
   }

   .errorRadio {
      color: #dc3545;
      /* #212523; */
   }


   .reqSig {
      border: 1px solid #dc3545;
   }

   #signature {
      border: 2px solid #dc3545;
      border-radius: 5px;
      background-image: linear-gradient(white, white);
      background-origin: border-box;
      background-clip: content-box, border-box;
   }

   #cosignature {
      border: 2px solid #dc3545;
      border-radius: 5px;
      background-image: linear-gradient(white, white);
      background-origin: border-box;
      background-clip: content-box, border-box;
   }

   .file-disabled {
      opacity: .65 !important;
      box-shadow: none;
      cursor: not-allowed !important;
      pointer-events: none !important;
   }




   .container-iframe {
      position: relative;
      width: 100%;
      height: 100%;
   }

   .responsive-iframe {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
   }


   #overlay {
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      align-items: center;
      display: flex;
      justify-content: center;
      overflow: visible;
      z-index: 9999;
      position: fixed;
      background-color: rgba(255, 255, 255, 0.5);
      /* background-color: black; */
   }


   .spinner {
      position: fixed;
      height: 60px;
      width: 60px;
      border: 3px solid transparent;
      border-top-color: #f96f14;
      margin: auto;
      border-radius: 50%;
      animation: spin 2s linear infinite;
   }

   .spinner:before,
   .spinner:after {
      content: '';
      position: fixed;
      border: 3px solid transparent;
      border-radius: 50%;
   }

   .spinner:before {
      border-top-color: #39cc78;
      top: -12px;
      left: -12px;
      right: -12px;
      bottom: -12px;
      animation: spin 3s linear infinite;
   }

   .spinner:after {
      border-top-color: black;
      top: 6px;
      left: 6px;
      right: 6px;
      bottom: 6px;
      animation: spin 4s linear infinite;
   }


   @keyframes spin {
      0% {
         transform: rotate(0deg);
      }

      100% {
         transform: rotate(360deg);
      }
   }

   .spinner.hidden {
      animation: fadeOut 1s;
      animation-fill-mode: forwards;
   }

   @keyframes fadeOut {
      100% {
         opacity: 0;
         visibility: hidden;
      }
   }

   label {
      font-weight: 400 !important;
   }


   @media (min-width: 1px) and (max-width: 767.98px) {
      .mobile_mode {
         display: block !important;
      }

      .h-title {
         font-size: 20px;
      }
   }


   /*Desktop, Laptop screen*/
   @media only screen and (min-width: 768px) {
      .desktop_mode {
         display: block !important;
      }

      object {
         min-height: 75vh !important;
      }

      .h-title {
         font-size: 28px;
      }
   }

   .form-control-border {
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-radius: 0;
      box-shadow: inherit;
      pointer-events: none;
   }
</style>